import store from '../../redux/store';
import { config } from '../../config';
import { normalize_roles } from '../../helpers/hasRole';
import { get_user_settings_from_database_and_save_user_to_cache } from './SessionService';

const get_client_roles = (tokenParsed) => {
    const clientRoles = tokenParsed?.resource_access?.[config.keycloak.clientId]?.roles;

    return Array.isArray(clientRoles) ? clientRoles : [];
};

const get_realm_roles = (tokenParsed) => {
    const realmRoles = tokenParsed?.realm_access?.roles;

    return Array.isArray(realmRoles) ? realmRoles : [];
};

export const build_keycloak_user = (keycloakInstance) => {
    const tokenParsed = keycloakInstance?.tokenParsed || {};
    const roles = normalize_roles([
        ...get_realm_roles(tokenParsed),
        ...get_client_roles(tokenParsed)
    ]);

    return {
        sub: tokenParsed?.sub || '',
        firstname: tokenParsed?.given_name || tokenParsed?.preferred_username || '',
        lastname: tokenParsed?.family_name || '',
        email: tokenParsed?.email || '',
        username: tokenParsed?.preferred_username || '',
        roles,
        rolesResolved: false
    };
};

export const sync_keycloak_session = (keycloakInstance, tokens) => {
    if (!tokens?.token) {
        clear_keycloak_session();
        return;
    }

    const user = build_keycloak_user(keycloakInstance);

    store.dispatch({
        type: 'SET_TOKEN',
        payload: tokens.token
    });

    store.dispatch({
        type: 'SET_USER',
        payload: user
    });

    get_user_settings_from_database_and_save_user_to_cache(keycloakInstance, user);
};

export const clear_keycloak_session = () => {
    store.dispatch({
        type: 'LOGOUT'
    });
};
